import { useCallback, useEffect, useState } from 'react';
import { apiJson } from '../api/client.js';
import { ChatPanel } from './ChatPanel.jsx';
import { fetchClientSocketToken, useChatSocket } from '../hooks/useChatSocket.js';

export function ClientChatWidget({ enabled, primaryColor }) {
  const [open, setOpen] = useState(false);
  const [conversationId, setConversationId] = useState(null);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState('');

  const accent = primaryColor && /^#[0-9A-Fa-f]{6}$/.test(primaryColor) ? primaryColor : '#4f46e5';

  const openChat = async () => {
    if (open) {
      setOpen(false);
      return;
    }
    setLoading(true);
    setError('');
    try {
      const data = await apiJson('/api/my/chat/open', { method: 'POST' });
      setConversationId(data.conversation?.id);
      setOpen(true);
    } catch (e) {
      setError(e.message);
    } finally {
      setLoading(false);
    }
  };

  const fetchToken = useCallback(
    () => fetchClientSocketToken(conversationId),
    [conversationId],
  );

  const { connected, connecting, messages, sendMessage, error: socketErr, appendMessage } = useChatSocket({
    fetchSocketToken: fetchToken,
    conversationId: open ? conversationId : null,
  });

  useEffect(() => {
    if (!enabled) {
      setOpen(false);
      setConversationId(null);
    }
  }, [enabled]);

  if (!enabled) return null;

  return (
    <>
      {open ? (
        <div className="chat-widget-panel auth-card flat">
          <div className="chat-widget-header">
            <strong>Support chat</strong>
            <button type="button" className="btn-link" onClick={() => setOpen(false)} aria-label="Close chat">
              ✕
            </button>
          </div>
          {error || socketErr ? <p className="err small">{error || socketErr}</p> : null}
          <ChatPanel
            messages={messages}
            connected={connected}
            connecting={connecting}
            onSend={sendMessage}
            onAttachmentUploaded={appendMessage}
            conversationId={conversationId}
            disabled={loading}
          />
        </div>
      ) : null}
      <button
        type="button"
        className="chat-widget-fab"
        data-tour="tour-chat-widget"
        style={{ background: accent }}
        onClick={() => void openChat()}
        disabled={loading}
        aria-label="Open chat"
        title="Chat with support"
      >
        {loading ? '…' : '💬'}
      </button>
    </>
  );
}
